module.exports = __webpack_public_path__ + "static/media/circle icon-1.43cc7851.png";